import SVGInject from '@iconfu/svg-inject';

export default class InjectSvgImages {
    // 1. describe and create/initiate our object
    constructor() {
        window.setTimeout(() => {
            this.svgToInject = document.querySelectorAll('.jsSvgInject');

            if (this.svgToInject.length) {
                SVGInject.setOptions({
                    afterInject: function (img, svg) {
                        svg.classList.remove('injectable');
                    },
                    onFail: function (img, svg) {
                        // if injection fails show the img element
                        img.classList.remove('jsSvgInject');
                        img.classList.remove('injectable');
                    },
                });
                this.events();
            }
        }, 1);
    }

    // 2. events
    events() {
        this.handleSvgInjection();
    }

    // 3. methods (function, action...)
    handleSvgInjection() {
        SVGInject(this.svgToInject);
    }
}
